export const SOCIAL_NETWORKS = [
  {
    id: 'instagram',
    label: 'Instagram',
    placeholder: 'https://instagram.com/votrecompte',
  },
  {
    id: 'facebook',
    label: 'Facebook',
    placeholder: 'https://facebook.com/votrepage',
  },
  {
    id: 'pinterest',
    label: 'Pinterest',
    placeholder: 'https://pinterest.com/votrecompte',
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    placeholder: 'https://tiktok.com/@votrecompte',
  },
];

export const emptySocialLinks = () =>
  SOCIAL_NETWORKS.reduce((acc, network) => {
    acc[network.id] = '';
    return acc;
  }, {});

export const normalizeSocialLinks = (links = {}) => {
  const normalized = emptySocialLinks();
  SOCIAL_NETWORKS.forEach((network) => {
    normalized[network.id] = links?.[network.id] || '';
  });
  return normalized;
};

export const socialLinksForApi = (links = {}) => {
  const payload = {};
  SOCIAL_NETWORKS.forEach((network) => {
    const value = (links?.[network.id] || '').trim();
    if (value) {
      payload[network.id] = value;
    }
  });
  return Object.keys(payload).length > 0 ? payload : null;
};

export const socialLinksForDisplay = (links = {}) =>
  SOCIAL_NETWORKS.map((network) => ({
    ...network,
    url: links?.[network.id] || null,
  })).filter((network) => Boolean(network.url));

export default SOCIAL_NETWORKS;
